<script>
import BaseSelectMulti from '@/components/BaseSelectMulti.vue';

export default {
  name: 'GuideCategoryList',
  components: { BaseSelectMulti },
  props: {
    guideCategories: Array,
    selectedCategories: Array,
  },
  computed: {
    uniqueCategories() {
      return [...new Set(this.guideCategories)];
    },

    categoryOptions() {
      return this.uniqueCategories.map(category => ({ label: category, value: category }));
    },
  },
  methods: {
    categoryStateChecker(category) {
      return this.selectedCategories.includes(category);
    },

    onSelect(category) {
      const check = this.selectedCategories.includes(category);

      if (!check) {
        this.$emit('toggle', [...this.selectedCategories, category]);
      } else {
        this.$emit('toggle', this.selectedCategories.filter(t => t !== category));
      }
    },

    changeValue(categories) {
      this.$emit('toggle', categories);
    },
  },
};
</script>

<template lang="pug">
.b-category-tag-list
  ._categories
    ._category(v-for="category in uniqueCategories" :key="category" :class="{ active: categoryStateChecker(category) }" @click="onSelect(category)") {{ category }}
  BaseSelectMulti._category-selector(:options="categoryOptions" :value="selectedCategories" label="Теги" @change="changeValue")
</template>

<style scoped lang="scss">
.category-tag-list {
  &__categories {
   display: flex;
   flex-wrap: wrap;
   gap: 15px;
   align-items: center;
  }

  &__category {
    padding: 7px 15px;
    background-color: rgba(235, 239, 242, 1);
    color: rgba(120, 140, 161, 1);
    border-radius: 4px;
    cursor: pointer;
  }

  &__category-selector {
    display: none;
  }
}

@media (min-width: 768px) and (max-width: 1199px) {
  .category-tag-list {
    &__categories {
      display: flex;
      flex-wrap: wrap;
      gap: 15px;
      align-items: center;
    }

    &__category-selector {
      display: none;
    }
  }
}

@media (min-width: 320px) and (max-width: 767px) {
  .category-tag-list {
    &__categories {
      display: none;
    }

    &__category-selector {
      display: block;
    }
  }
}

.active {
  background-color: rgba(130, 188, 235, 1);
  color: rgba(255, 255, 255, 1);
  font-weight: 700;
}
</style>
